import { Typography, Container as UnstyledContainer } from "@mui/material";
import styled from '@mui/styled-engine';
import React from "react";
import { useTranslation } from "react-i18next";
import styles from "../../../styles";
import logo from "../../assets/logo.png";
import useTitle from "../../hooks/useTitle";

const Container = styled(UnstyledContainer)(({ theme }: any) => ({
  height: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
}));

const NotFoundMessage = styled(Typography)(({ theme }: any) => ({
  fontWeight: 600,
  paddingBottom: theme.spacing(6),
}));


const Logo = styled("img")(({ theme }: any) => ({
  maxWidth: "70%",
  maxHeight: "60%",
  paddingBottom: theme.spacing(6),
}));

const BackButton = styled("a")(({ theme }: any) => ({
  ...styles.pinkBackground,
  padding: theme.spacing(1, 3),
  fontSize: "1rem",
  borderRadius: "2rem",
  lineHeight: "2rem",
  textDecoration: "none",
}));

export const NotFound = () => {

  const { t } = useTranslation();
  useTitle(t("BabyWatch") + " - " + t("Page not found"));

  return (
    <Container>
      <Logo
        src={logo}
        alt="page not found logo"
      />
      <NotFoundMessage variant="h4" color="primary">
        {t("Page not found")}
      </NotFoundMessage>
      <BackButton href="/" color="primary"> {t("Back to homepage")} </BackButton>
    </Container>
  );
};
